module.exports = __webpack_public_path__ + "static/media/51.af36fa7d.png";